import { keys } from 'lodash';
import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { bulkUpdateCampaignsGroups } from 'modules/campaigns/modules/campaigns-group/flows';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isCampaignGroupEnabled } from '../../../../../config/report-predicates/isCampaignGroupEnabled';
import { isOnlySponsored } from '../../../../../config/report-predicates/isOnlySponsored';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { BULK_ACTION } from '../../../components/BulkActionToolbar/bulkAction';
import { bulkEditCampaignsGroup } from '../../../flows';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { CAMPAIGNS_GROUPS_REPORT_ID } from './campaignGroupReportId';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { graph } from './graph';
import { customColumns, defaultColumns, performanceColumns, setupColumns } from './reportPresets';

export const campaignsGroupReportConfig = {
    id: CAMPAIGNS_GROUPS_REPORT_ID,
    label: 'Campaign Groups',
    permissions: [REPORT_PERMISSION.CAMPAIGN_GROUPS_REPORT_VIEW],
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
    },
    visibilityCondition: props => isOnlySponsored(props) && isCampaignGroupEnabled(props),
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-group-report',
    graph,
    rowIdField: FIELDS.CAMPAIGNS_GROUP_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
        [REPORT_PRESET.SETUP]: { columns: setupColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byCampaignsGroup.search.placeholder',
    searchField: FIELDS.CAMPAIGNS_GROUP_NAME.field,
    inlineEditPermissions: ['CAMPAIGN_EDIT', 'EDIT_CAMPAIGN_GROUP'],
    sortMap: {
        [FIELDS.BUDGET.field]: 'budget_limit',
    },
    initialFilters: [],
    filters: [{ id: FILTER_TYPE.CAMPAIGN_GROUP_STATUS, multiSelect: true, minVisibleCount: 4 }],
    bulkActions: [
        {
            key: BULK_ACTION.PLAY,
            handler:
                ({ selectedRows, accountName }) =>
                dispatch => {
                    dispatch(
                        bulkUpdateCampaignsGroups({
                            accountId: accountName,
                            campaignGroupIds: keys(selectedRows),
                            changes: {
                                isActive: true,
                            },
                        })
                    );
                },
        },
        {
            key: BULK_ACTION.PAUSE,
            handler:
                ({ selectedRows, accountName }) =>
                dispatch => {
                    dispatch(
                        bulkUpdateCampaignsGroups({
                            accountId: accountName,
                            campaignGroupIds: keys(selectedRows),
                            changes: {
                                isActive: false,
                            },
                        })
                    );
                },
        },
        {
            key: BULK_ACTION.EDIT,
            handler:
                ({ selectedRows, accountName, history }) =>
                dispatch => {
                    dispatch(
                        bulkEditCampaignsGroup({
                            history,
                            accountId: accountName,
                            selectedRowsIds: keys(selectedRows),
                        })
                    );
                },
        },
    ],
};

export default campaignsGroupReportConfig;
